import { render, staticRenderFns } from "./EV3EditorViewItemHolder.vue?vue&type=template&id=22cd3166&scoped=true"
import script from "./EV3EditorViewItemHolder.vue?vue&type=script&lang=js"
export * from "./EV3EditorViewItemHolder.vue?vue&type=script&lang=js"
import style0 from "./EV3EditorViewItemHolder.vue?vue&type=style&index=0&id=22cd3166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd3166",
  null
  
)

export default component.exports